import { Addon as GeneratedAddon } from '@vendasta/marketplace-apps/v1';
import { File } from './file.model';
import { formatDisplayPrice, BillingFrequency } from '@vendasta/shared';

export class Addon extends GeneratedAddon {
  // These fields are needed to properly
  // display the Addons parent information in the navigation
  productIcon: string;
  productName: string;
  private _endUserMarketingFiles: File[] | undefined;
  private _resellerMarketingFiles: File[] | undefined;

  static fromApi(data: any): Addon {
    const addon: any = {};
    data = data || {};
    Object.assign(addon, data);
    if (data.created) {
      addon['created'] = new Date(data.created);
    }
    if (data.updated) {
      addon['updated'] = new Date(data.updated);
    }
    return new Addon(addon);
  }

  constructor(data?: any) {
    super();
    data = data || {};
    this.addonId = data.addonId;
    this.appId = data.appId;
    this.tagline = data.tagline;
    this.price = data.price;
    this.title = data.title;
    this.description = data.description;
    this.created = data.created;
    this.updated = data.updated;
    this.orderForm = data.orderForm;
    this.usesOrderForm = data.usesOrderForm;
    this.approved = data.approved;
    this.icon = data.icon;
    this.bannerImage = data.bannerImage;
    this.resellerMarketing = data.resellerMarketing;
    this.endUserMarketing = data.endUserMarketing;
    this.billingFrequency = data.billingFrequency;
    this.serviceModel = data.serviceModel;
    this.discoverable = data.discoverable;
    this.screenshots = data.screenshots;
    this.productName = data.productName;
    this.productIcon = data.productIcon;
    this.multipleActivations = data.multipleActivations;
    this.restrictions = data.restrictions;
    this.activationRequiresApproval = data.activationRequiresApproval;
    this.billingId = data.billingId;
    this.commitment = data.commitment;
    this.currency = data.currency;
    this.usesCustomPricing = data.usesCustomPricing;
  }

  get endUserMarketingFiles(): File[] | null {
    if (this._endUserMarketingFiles) {
      return this._endUserMarketingFiles;
    } else {
      if (this.endUserMarketing.files) {
        this._endUserMarketingFiles = this.endUserMarketing.files.map((url) => new File(url));
        return this._endUserMarketingFiles;
      }
    }
    return null;
  }

  get resellerMarketingFiles(): File[] | null {
    if (this._resellerMarketingFiles) {
      return this._resellerMarketingFiles;
    } else {
      if (this.resellerMarketing.files) {
        this._resellerMarketingFiles = this.resellerMarketing.files.map((url) => new File(url));
        return this._resellerMarketingFiles;
      }
    }
    return null;
  }

  get formattedPrice(): string {
    const billingString = this.billingFrequency ? this.billingFrequency : 'monthly';
    return formatDisplayPrice(this.price, this.currency, billingString as BillingFrequency);
  }
}
